export const imageOutpaintGlobalId = "ImageOutPaint";
export const imageCropGlobalId = "ImageCropper";
